import DocketService from '@/services/requests/docketService'
import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      contractorRules: [
        //v => !!v || 'Contractor is required'
      ],
      driverRules: [
        v => !!v || 'Driver is required',
        v => (
          this.filteredDrivers.filter(record => {
            return record.id == v
          }).length > 0
        ) || 'Driver is not in list',
      ],
      siteRules: [
        v => !!v || 'Site is required'
      ],
      regoRules: [
        v => !!v || 'Registration is required',
        v => (
          this.filteredVehicles.filter(record => {
            return record.id == v
          }).length > 0
        ) || 'Vehicle is not in the list',
      ],
      externalRefRules: [
        v => Rules.isRequired(v),
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 50),
        //v => !v ? true : v.length < 50 && v.length > 1 || 'Field must be between 1 and 50 characters'
      ],
      dateRules: [
        v => Rules.isRequired(v),
        v => Rules.isInValidDateRange(v)
      ],
      notesRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 255)
      ],
    }
  }
}